/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { createApiRef } from '@backstage/core-plugin-api';
import {
  EvaluationUsageType,
  FeatureFlagType,
  ListEnvironmentType,
  ListFeatureFlagType,
} from '../types';

export const LaunchDarklyApiRef = createApiRef<LaunchDarklyApi>({
  id: 'plugin.launchdarklydashboard.service',
});

export type LaunchDarklyApi = {
  getListFeatureFlag({
    projectKey,
    env,
    offset
  }: {
    projectKey: string;
    env: string;
    offset: number
  }): Promise<ListFeatureFlagType>;

  getListEnvironments({
    projectKey,
  }: {
    projectKey: string | 'default';
  }): Promise<ListEnvironmentType>;

  getFeatureFlag({
    featureFlagKey,
    projectKey,
  }: {
    projectKey: string;
    featureFlagKey: string;
  }): Promise<FeatureFlagType>;

  getEvaluationsUsage({
    featureFlagKey,
    projectKey,
    environmentKey,
    from,
    to,
    tz,
  }: {
    projectKey: string,
    featureFlagKey: string,
    environmentKey: string,
    from?: string,
    to?: string,
    tz?: string,
  }): Promise<EvaluationUsageType>;
};
